module.exports = __webpack_public_path__ + "img/r4_xinghuishengguan.02006022.jpg";